import { defineMessages } from 'react-intl';
import {  Plug } from "@plone/volto/components/manage/Pluggable";

import {
  LoginFormManage,
  Token,
  SessionExpired,
  LoginUnicoSessionTimer
} from './components';

import {
  authorize_uri,
  is_active,
  login_form_allowed,
  loginunico_token,
  external_logout,
  expires_gmt,
  loginunico_renew_login,
  redirect_after_login,
} from './reducers';



defineMessages({});

const applyConfig = (config) => {
  // addon reducers
  config.addonReducers = {
    ...config.addonReducers,
    authorize_uri,
    is_active,
    login_form_allowed,
    loginunico_token,
    external_logout,
    expires_gmt,
    loginunico_renew_login,
    redirect_after_login,
  };
  // addon routers
  config.addonRoutes.push(
    {
      path: ['/login_form_manage', '/**/login_form_manage'],
      component: LoginFormManage,
    },
    {
      path: ['/loginunico_token', '/**/loginunico_token'],
      component: Token,
    },
    {
      path: ['/session_expired', '/**/session_expired'],
      component: SessionExpired,
    },
  );

  config.settings.appExtras = [
    ...(config.settings.appExtras ?? []),
    {
      match: "",
      component: () => (
        <Plug pluggable="main.toolbar.bottom" id="session-timer">
          <LoginUnicoSessionTimer />
        </Plug>
      ),
    },
  ];

  return config;
};

export default applyConfig;

